import { FAILURE_REASONS } from './constants';
import { translatorFor } from './i18n';
const t = translatorFor('connection_errors');
const REASON_MESSAGE_KEYS = {
    [FAILURE_REASONS.MISSING_REQUIRED_FIELD]: 'missing_fields',
    [FAILURE_REASONS.INVALID_CREDENTIALS]: 'invalid_credentials',
    [FAILURE_REASONS.APP_NOT_CONNECTED]: 'app_not_connected',
    [FAILURE_REASONS.UNREACHABLE]: 'unreachable',
    [FAILURE_REASONS.TENANT_CLAIM_MISSING]: 'tenant_claim_missing',
    [FAILURE_REASONS.TENANT_ROUTE_COLLISION]: 'tenant_route_collision'
};
export function connectionErrorMessage(reason) {
    const key = reason ? REASON_MESSAGE_KEYS[reason] : undefined;
    return t(key !== null && key !== void 0 ? key : 'save_failed');
}
